import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthCard } from '../components/AuthCard/AuthCard';
import { ForgotPasswordForm } from '../components/ForgotPasswordForm/ForgotPasswordForm';
import { useAuth } from '../hooks/useAuth';
import { AUTH_ROUTES } from '../authConstants';

export function ForgotPasswordPage() {
  const { isAuthenticated, isInitialized } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isInitialized && isAuthenticated) {
      navigate(AUTH_ROUTES.HOME, { replace: true });
    }
  }, [isAuthenticated, isInitialized, navigate]);

  return (
    <AuthCard>
      <ForgotPasswordForm />
    </AuthCard>
  );
}
